module.exports = __webpack_public_path__ + "img/plant_5_small.8aae2f92.webp";